// extracted by mini-css-extract-plugin
export default {"dialog":"_5Eis","header":"z_Miv","tabsContainer":"UGUZj"};